/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'photo': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g clip-path="url(#clip0_7071_15471)" _fill="#0B2C62"><path pid="0" d="M22.92 5.407a2.161 2.161 0 00-1.715-.846h-.016c-.673 0-1.308.318-1.71.858l-6.244 8.38a.865.865 0 01-1.22.17l-3.267-2.5a2.157 2.157 0 00-2.789.137L.687 16.527A2.162 2.162 0 000 18.108v9.815c0 1.194.968 2.162 2.162 2.162h27.676A2.162 2.162 0 0032 27.923v-9.939c0-.473-.159-.94-.446-1.315L22.92 5.407zM14.27 5.004a3.027 3.027 0 11-6.054 0 3.027 3.027 0 016.054 0z"/></g><defs><clipPath id="clip0_7071_15471"><path pid="1" _fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs>'
  }
})
